export default {
	apiKey: "AIzaSyDF_AaZxsCu_XiCk-bGwc9tW4szUWHpLeY",
	authDomain: "menu-qr.firebaseapp.com",
	databaseURL: "https://menu-qr.firebaseio.com",
	projectId: "menu-qr",
	storageBucket: "menu-qr.appspot.com",
	messagingSenderId: "574446996542",
	appId: "1:574446996542:web:280fbf08085ecfa70d956f"
};
